import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

const selectRoot = ({ storingPhoneNumber }: RootState) => storingPhoneNumber;

export const selectStoringPhoneNumber = createSelector(
    selectRoot,
    ({ storingPhoneNumber }) => storingPhoneNumber,
);
